// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--38F6g","primary":"button-module--primary--2PEdt","secondary":"button-module--secondary--z4Vre"};